module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/4f2885172e42580ef5674c3646a1be2b.png";